/**
 * ============================================================
 * PubCardCompact.js — Compact Publication Entry
 * ============================================================
 *
 * This compact version of a pub card shows only the title + icon.
 * Full citation lives in PubCard (on the main Publications page).
*
 * Props:
 *   publication: {
 *     id,
 *     title,
 *     year,
 *     citation,
 *     doiurl,
 *     pdf
 *   }
 *
 * Layout:
 *   [ ICON ]  [ TITLE ]
 *
 * Used in:
 *   -> Person.js   (person's publication list)
 *   -> Project.js  (project's publication list)
 *
 */

import React from "react";
import "./css/PubCardCompact.css";

import { pubPdf } from "../utils/mediaPaths";


// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function PubCardCompact({ publication }) {

  if (!publication) return null;

  const { title, year, doiurl, pdf } = publication;

  // ----------------------------------------------------------
  // Determine icon + link priority
  // Priority:
  //   1. DOI URL
  //   2. Local PDF file
  // ----------------------------------------------------------
  let iconSrc = null;
  let iconLink = null;

  if (doiurl && doiurl !== "null") {
    iconSrc = "/images/doi.png";
    iconLink = doiurl;
  } else if (pdf && pdf !== "null") {
    iconSrc = "/images/pdf.png";
    iconLink = pubPdf(pdf);
  }

  // ----------------------------------------------------------
  // Render
  // ----------------------------------------------------------
  return (
    <div className="pub-card-compact">

      {/* ----- LINKED ICON (if DOI or PDF) or PLACEHOLDER ----- */}
      {iconSrc ? (
        <a
          href={iconLink}
          target="_blank"
          rel="noreferrer"
          className="pub-card-compact-icon-link"
        >
          <img
            className="pub-card-compact-icon"
            src={iconSrc}
            alt="publication icon"
          />
        </a>
      ) : (
        <div className="pub-card-compact-icon-placeholder" />
      )}

      {/* ----- TITLE ----- */}
      <div className="pub-card-compact-text-wrapper">
        <div className="pub-card-compact-title">
          {title}&nbsp;({year})
        </div>
      </div>

    </div>
  );
}

export default PubCardCompact;